<template>
  <div class="contain">
    <div class="enr_con">
       <div class="imgurl"> <img src="../assets/images/22.png" alt=""> </div>
        <p class="navigation fl">您当前所在的位置： <router-link to="/home/index" class="home">首页</router-link>&nbsp;>&nbsp;<a href="javascript:;" style="color:#666">成绩查询</a></p>
      <div class="main">
        <left-comp></left-comp>
        <div class="enr_right">
          <div class="tab-bd  enroll" v-if="cardFlag">
            <p class="tit">成绩查询</p>

            <ul class="ull">
              <div class="studentname">姓名：{{data.xm}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;考生号：{{data.kh}}</div>
              <li>考试总成绩<span>总分：{{data.all_score}}</span></li>
              <li>省考成绩<span>总分：{{data.province_score}}</span> </li>
              <li>校考成绩<span>总分：{{data.score}}</span></li>
            </ul>

            <table border="1 " class="formcontent score mt30" style="display:none">
              <tr>
                <th width="25% " colspan="4">{{data.year}}年高职考试录取结果</th>
              </tr>
              <tr>
                <td width="33%" align="center"> 报考院系</td>
                <td align="center">{{data.wish_dept ? data.wish_dept :'无'}}</td>
              </tr>
              <tr>
                <td width="25%" align="center"> 报考专业</td>
                <td align="center">{{data.wish_zymc ? data.wish_zymc: '无'}}</td>
              </tr>
              <tr>
                <td width="25%" align="center"> 录取结果</td>
                <td align="center">{{data.source ? data.cource : '无'}}</td>
              </tr>
              <tr>
                <td width="25%" align="center">录取专业</td>
                <td align="center">{{data.luqu_zymc ? data.luqu_zymc : '无'}}</td>
              </tr>
            </table>
          </div>
          <div class="nodata tab-bd  enroll" v-if="!cardFlag">
            暂未查询到数据，请过一段时间后再试~
          </div>
        </div>
      </div>
    </div>
    <page-load v-if="loading"></page-load>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
  </div>
</template>

<script>
import leftComp from "../components/leftComp";
import { scoreSearch } from "../api/updata";
import pageLoad from "../pageload/pageload";

export default {
  components: { leftComp, pageLoad },
  data() {
    return {
      data: {}, //保存返回数据
      sfzjh: "", //身份证
      xm: "", //姓名
      batch_id: "", //id
      cardFlag: true,
      tip: {}, //提示语
      loading: true, //预加载
      tipShow: false //提示框默认状态
    };
  },
  created() {
    this.sfzjh = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).sfzjh; //身份证
    this.xm = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).xm; //姓名
    this.batch_id = JSON.parse(
      this.global.Base64.decode(sessionStorage.getItem("INFO"))
    ).batch_id; //id
    this._scoreSearch();
  },
  methods: {
    _scoreSearch() {
      if (this.sfzjh == null || this.xm == null || this.batch_id == null) {
        this.loading = false;
        this.tipCtr("学生信息缺失");
      } else {
        let module = {
          sfzjh: this.global.Base64.encode(this.sfzjh),
          xm: this.xm,
          batch_id: this.batch_id
        };
        this.loading = true;
        scoreSearch(module)
          .then(res => {
            this.loading = false;
            if (res.status) {
              this.data = res.data;
            } else {
              this.cardFlag = false;
              return false;
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      }
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    }
  }
};
</script>
<style scoped>
.bj {
  background-color: #99c9fb;
}

.nodata {
  width: 100%;
  text-align: center;
  font-size: 18px;
  margin-top: 100px;
}
.tit {
  font-size: 22px;
  letter-spacing: 0.77px;
  color: #333333;
  font-weight: bold;
}
.name {
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.49px;
  line-height: 50px;
}
.ull {
  width: 98%;
  margin: 0 auto;
  padding: 2%;
  border: 2px solid #ccc;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.5px;
}
/* 姓名 */
.ull .studentname {
  width: 100%;
  height: 60px;
  line-height: 60px;
}
.ull li {
  width: 100%;
  padding: 0 2%;
  margin: 0 auto;
  height: 50px;
  line-height: 50px;
  margin: 5px 0;
  border-radius: 4px;
  transition: all 0.6s;
}
.ull li:nth-child(2n) {
  background: #99c9fb;
}
.ull li:nth-child(2n-1) {
  background: #deedfe;
}
.ull li span {
  float: right;
  color: coral;
}
.ull li:hover {
  box-shadow: 0 2px 4px 0 #e0e0e0;
  transform: translate(0, -3px);
  -webkit-transform: translate(0, -3px);
  -moz-transform: translate(0, -3px);
  -o-transform: translate(0, -3px);
  -ms-transform: translate(0, -3px);
}
</style>



// WEBPACK FOOTER //
// src/view/queryList.vue